import React, { FC, memo, ReactNode } from 'react';

import { dom } from 'app/utils';
import { DataView as Component, DataViewProps as Props } from '../external';
import { IComponent } from '../types';
import { IPaginator, IPaging, ITemplate } from './types';

export interface IView<T> extends IComponent {
  items?: T[];
  layout?: 'grid' | 'list';
  columns?: number;
  template: (item: T, index: number, options: ITemplate) => ReactNode;
  loading?: boolean,
  paginator?: IPaginator;
  total?: number;

  onPage?: (e: IPaging) => void;
}

export const View: FC<IView<any>> = memo(({ id, className, style, layout, columns, items, template, loading, paginator, onPage }) => {
  if (!layout) layout = 'list';

  const column = (layout === 'grid' ? Math.floor(12 / Math.max(Math.min(columns ?? 1, 12), 1)) : 12);

  const props: Props = { id, style, layout, loading,
    className: dom.className('i-component', 'i-view', className),
    listTemplate: (template ? (items): any => (
      <div className="grid grid-nogutter">
        { items?.map((item, i) => (
          <div key={i} className={`col-${column} mb-1`}>
            { template(item, i, { layout }) }
          </div>
        )) }
      </div>
    ): undefined),
    value: items,
    paginator: !!paginator,
    paginatorClassName: dom.className(paginator?.className),
    paginatorPosition: (paginator?.position ?? 'bottom'),

    onPage: dom.handle(onPage, ({ page, pageCount, rows }) => ({ rows,
      page: (page ?? 0),
      count: pageCount,
    })),
  };

  return (
    <Component { ...props } />
  );
});
